import { ref } from 'vue';

export function useReorder(onMove: (from: number, to: number) => void) {
  const draggingIndex = ref<number | null>(null);
  const dragOverIndex = ref<number | null>(null);
  const dragOver = ref(false);

  function onDragOver() {
    dragOver.value = true;
  }
  function onDragLeave() {
    dragOver.value = false;
  }
  function onDrop(e: DragEvent) {
    dragOver.value = false;
    return e;
  }

  function onDragStart(idx: number, e: DragEvent) {
    draggingIndex.value = idx;
    dragOverIndex.value = null;
    if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move';
  }
  function onItemDragOver(idx: number) {
    dragOverIndex.value = idx;
  }
  function onItemDrop(idx: number) {
    if (draggingIndex.value === null) return;
    onMove(draggingIndex.value, idx);
    draggingIndex.value = null;
    dragOverIndex.value = null;
  }
  function onDragEnd() {
    draggingIndex.value = null;
    dragOverIndex.value = null;
  }

  return {
    draggingIndex,
    dragOverIndex,
    dragOver,
    onDragOver,
    onDragLeave,
    onDrop,
    onDragStart,
    onItemDragOver,
    onItemDrop,
    onDragEnd,
  };
}
